import React from 'react';
import { Badge } from '../../components/ui/badge';
import { parseLocalDate } from '../../lib/dateUtils';

export const MAX_COMPROBANTES = 3;
export const ALLOWED_TYPES = [
  'image/jpeg', 'image/jpg', 'image/png', 'image/webp',
  'image/heic', 'image/heif', 'application/pdf',
];
export const MAX_FILE_MB = 8;

export const isPdfUrl = (url) => /\.pdf(\?|$)/i.test(url || '');

export const formatCurrency = (amount) =>
  '$' + Number(amount || 0).toLocaleString('es-GT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const d = parseLocalDate(dateString);
  return d ? d.toLocaleDateString('es-ES') : 'N/A';
};

const ESTADO_COLORS = {
  Pendiente: 'bg-red-100 text-red-800 border-red-300',
  Parcial: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  Pagada: 'bg-green-100 text-green-800 border-green-300',
};

export const EstadoPagoBadge = ({ estado }) => (
  <Badge
    className={`${ESTADO_COLORS[estado] || ''} border`}
    data-testid={`badge-${(estado || '').toLowerCase()}`}
  >
    {estado}
  </Badge>
);
